import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Image } from 'foundations-components/transitional/components/Image';
import { getPublicLang } from 'academy-common-lib/utils/url';
import { useEffect } from 'react';
import { TreatmentsClient } from '../../../experiments/laboratoryClient';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';

// English company logos
// @ts-expect-error Could not find a declaration file for module
import panasonicLogo from 'bender-url!../../../images/homepage/company-logos/Panasonic_Group_logo.png';
// @ts-expect-error Could not find a declaration file for module
import redditLogo from 'bender-url!../../../images/homepage/company-logos/reddit-logo.webp';
// @ts-expect-error Could not find a declaration file for module
import zapierLogo from 'bender-url!../../../images/homepage/company-logos/zapier-logo.png';
// @ts-expect-error Could not find a declaration file for module
import ebayLogo from 'bender-url!../../../images/homepage/company-logos/ebay-logo.png';
// @ts-expect-error Could not find a declaration file for module
import doordashLogo from 'bender-url!../../../images/homepage/company-logos/doordash-logo.png';

// Spanish company logos
// @ts-expect-error Could not find a declaration file for module
import docplannerLogo from 'bender-url!../../../images/homepage/company-logos-es/Docplanner.webp';
// @ts-expect-error Could not find a declaration file for module
import nissanLogo from 'bender-url!../../../images/homepage/company-logos-es/Nissan.svg';
// @ts-expect-error Could not find a declaration file for module
import copaAirlinesLogo from 'bender-url!../../../images/homepage/company-logos-es/Copa-Airlines-blue.svg';
// @ts-expect-error Could not find a declaration file for module
import casioLogo from 'bender-url!../../../images/homepage/company-logos-es/Casio_Logo.png';
// @ts-expect-error Could not find a declaration file for module
import ebanxLogo from 'bender-url!../../../images/homepage/company-logos-es/ebanx.webp';
// @ts-expect-error Could not find a declaration file for module
import nuboxLogo from 'bender-url!../../../images/homepage/company-logos-es/Nubox-1-1.webp';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ENGLISH_COMPANY_LOGOS = [{
  name: 'Panasonic',
  src: panasonicLogo
}, {
  name: 'Reddit',
  src: redditLogo
}, {
  name: 'Zapier',
  src: zapierLogo
}, {
  name: 'eBay',
  src: ebayLogo
}, {
  name: 'DoorDash',
  src: doordashLogo
}];
const SPANISH_COMPANY_LOGOS = [{
  name: 'Nubox',
  src: nuboxLogo
}, {
  name: 'Docplanner',
  src: docplannerLogo
}, {
  name: 'Copa Airlines',
  src: copaAirlinesLogo
}, {
  name: 'Casio',
  src: casioLogo
}, {
  name: 'Nissan',
  src: nissanLogo
}, {
  name: 'EBANX',
  src: ebanxLogo
}];
const CustomerLogoBannerSection = () => {
  const currentLang = getPublicLang();
  const companyLogos = currentLang === 'es' ? SPANISH_COMPANY_LOGOS : ENGLISH_COMPANY_LOGOS;
  const {
    isMobile
  } = useMediaQuery();
  const isMarketingThemeEnabled = getMarketingThemePreference();
  useEffect(() => {
    if (['en', 'es'].includes(currentLang)) {
      TreatmentsClient.logExposure('acad-0033');
    }
  }, [currentLang]);
  return /*#__PURE__*/_jsxs(View, {
    as: "section",
    backgroundColor: "do-not-use-gypsum",
    paddingBlockStart: isMobile || isMarketingThemeEnabled ? '800' : '1600',
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(H2, {
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.homepage.customerLogoBanner.heading"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
      children: companyLogos.map(company => /*#__PURE__*/_jsx(Box, {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        padding: "500",
        children: /*#__PURE__*/_jsx(Image, {
          alt: company.name,
          height: 20,
          src: company.src,
          width: 80
        })
      }, company.name))
    })]
  });
};
export default CustomerLogoBannerSection;